import { useEffect, useState } from "react";
import { useSocket } from "../../../contexts/SocketContext";
import { DROPDOWN_VALUES_CHANGED, fetchDropdownValues } from "../../models/shared/dropdownValuesModel";

export function useVehicleDropdownOptions(open) {
  const { socket } = useSocket();
  const [rows, setRows] = useState({});
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!open) return;
    let alive = true;
    setError("");
    Promise.all(["engine_layout", "transmission_type", "drivetrain"].map(async mode => [mode, (await fetchDropdownValues(mode)).rows]))
      .then(entries => { if (alive) setRows(Object.fromEntries(entries)); })
      .catch(err => { if (alive) setError(err.message); });
    return () => { alive = false; };
  }, [open, revision]);
  useEffect(() => {
    if (!open) return;
    const refresh = payload => {
      const mode = payload?.detail?.mode || payload?.mode;
      if (["engine_layout", "transmission_type", "drivetrain"].includes(mode)) setRevision(current => current + 1);
    };
    const reconnect = () => setRevision(current => current + 1);
    window.addEventListener(DROPDOWN_VALUES_CHANGED, refresh);
    socket?.on("misc_config_updated", refresh);
    socket?.on("connect", reconnect);
    return () => { window.removeEventListener(DROPDOWN_VALUES_CHANGED, refresh); socket?.off("misc_config_updated", refresh); socket?.off("connect", reconnect); };
  }, [socket, open]);
  return { rows, error, retry: () => setRevision(current => current + 1) };
}
